import React, { FunctionComponent } from 'react'
import { QuoteCustomerModal } from '../react/modals/quote-customer-modal/QuoteCustomerModal'
import { ServiceModal } from '../react/modals/service-modal/ServiceModal'
import { MarkAsUnfulfilledModal } from '../react/modals/mark-as-unfulfilled-modal/MarkAsUnfulfilledModal'
import { LSPayRecoveryModal } from '../payments/lspay-recovery-modal/LSPayRecoveryModal'
import { ConfirmSaleWithPaymentsModal } from '../react/modals/common/ConfirmSaleWithPaymentsModal'
import { ConfirmSaleWithGiftCards } from '../react/modals/common/ConfirmSaleWithGiftcards'
import {
  ConfirmSaleAndFinaliseModal,
  ModalContextType,
} from '../react/modals/common/ConfirmSaleAndFinalise'
import { useSaleModals } from './useSaleModals'
import { OpenRegisterModal } from './OpenRegisterModal'
import { AddCustomerModal } from './AddCustomerModal'
import { ErroredSalesModal } from './ErroredSalesModal'

export const SaleModals: FunctionComponent = () => {
  const { state, closeSaleModals } = useSaleModals()

  if (state.type === 'QuoteCustomer') {
    return <QuoteCustomerModal close={state.onClose} />
  }

  if (state.type === 'Service') {
    return <ServiceModal close={closeSaleModals} />
  }

  if (state.type === 'Unfulfilled') {
    return (
      <MarkAsUnfulfilledModal outlets={state.outlets} close={closeSaleModals} />
    )
  }

  if (state.type === 'OpenRegister') {
    return <OpenRegisterModal onClose={state.onClose} />
  }

  if (state.type === 'AddCustomer') {
    return <AddCustomerModal onClose={closeSaleModals} />
  }

  if (state.type === 'LSPayRecovery') {
    return <LSPayRecoveryModal saleId={state.saleId} close={state.onClose} />
  }

  if (state.type === 'ConfirmSaleWithPayments') {
    return (
      <ConfirmSaleWithPaymentsModal
        close={() => {
          closeSaleModals()
          if (state.onClose) {
            state.onClose()
          }
        }}
      />
    )
  }

  if (state.type === 'ConfirmSaleWithGiftcards') {
    return (
      <ConfirmSaleWithGiftCards
        close={() => {
          closeSaleModals()
          if (state.onClose) {
            state.onClose()
          }
        }}
      />
    )
  }

  if (state.type === 'ErroredSales') {
    return <ErroredSalesModal onClose={closeSaleModals} />
  }

  if (state.type === 'ConfirmSaleAndFinalise') {
    return (
      <ConfirmSaleAndFinaliseModal
        close={() => {
          closeSaleModals()
          if (state.onClose) {
            state.onClose()
          }
        }}
        context={state.context as ModalContextType}
      />
    )
  }

  return null
}
